import { History } from "history";

import {
  CreateSupplicationRequest,
  PaginateQuery,
  SupplicationDto,
  UpdateSupplicationRequest,
} from "../../interfaces";
import { Paginated } from "../../models";

//#region Get Supplications

export const GET_SUPPLICATIONS = "GET_SUPPLICATIONS";
export const GET_SUPPLICATIONS_SUCCESS: any = "GET_SUPPLICATIONS_SUCCESS";
export const GET_SUPPLICATIONS_ERROR: any = "GET_SUPPLICATIONS_ERROR";

export interface GetSupplicationsAction {
  type: typeof GET_SUPPLICATIONS;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetSupplicationsSuccessAction {
  type: typeof GET_SUPPLICATIONS_SUCCESS;
  payload: Paginated<SupplicationDto>;
}

export interface GetSupplicationsErrorAction {
  type: typeof GET_SUPPLICATIONS_ERROR;
  payload: any;
}
//#endregion

//#region Get Supplication

export const GET_SUPPLICATION = "GET_SUPPLICATION";
export const GET_SUPPLICATION_SUCCESS: any = "GET_SUPPLICATION_SUCCESS";
export const GET_SUPPLICATION_ERROR: any = "GET_SUPPLICATION_ERROR";

export interface GetSupplicationAction {
  type: typeof GET_SUPPLICATION;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetSupplicationSuccessAction {
  type: typeof GET_SUPPLICATION_SUCCESS;
  payload: SupplicationDto;
}

export interface GetSupplicationErrorAction {
  type: typeof GET_SUPPLICATION_ERROR;
  payload: any;
}
//#endregion

//#region Add Supplication

export const ADD_SUPPLICATION = "ADD_SUPPLICATION";
export const ADD_SUPPLICATION_SUCCESS: any = "ADD_SUPPLICATION_SUCCESS";
export const ADD_SUPPLICATION_ERROR: any = "ADD_SUPPLICATION_ERROR";

export interface AddSupplicationAction {
  type: typeof ADD_SUPPLICATION;
  payload: {
    request: CreateSupplicationRequest;
    history: History;
  };
}

export interface AddSupplicationSuccessAction {
  type: typeof ADD_SUPPLICATION_SUCCESS;
  payload: null;
}

export interface AddSupplicationErrorAction {
  type: typeof ADD_SUPPLICATION_ERROR;
  payload: any;
}
//#endregion

//#region Update Supplication

export const UPDATE_SUPPLICATION = "UPDATE_SUPPLICATION";
export const UPDATE_SUPPLICATION_SUCCESS: any = "UPDATE_SUPPLICATION_SUCCESS";
export const UPDATE_SUPPLICATION_ERROR: any = "UPDATE_SUPPLICATION_ERROR";

export interface UpdateSupplicationAction {
  type: typeof UPDATE_SUPPLICATION;
  payload: {
    id: string;
    request: UpdateSupplicationRequest;
    history: History;
  };
}

export interface UpdateSupplicationSuccessAction {
  type: typeof UPDATE_SUPPLICATION_SUCCESS;
  payload: null;
}

export interface UpdateSupplicationErrorAction {
  type: typeof UPDATE_SUPPLICATION_ERROR;
  payload: any;
}
//#endregion

//#region Delete Supplication

export const DELETE_SUPPLICATION_CONSENT: any = "DELETE_SUPPLICATION_CONSENT";
export const DELETE_SUPPLICATION = "DELETE_SUPPLICATION";
export const DELETE_SUPPLICATION_SUCCESS: any = "DELETE_SUPPLICATION_SUCCESS";
export const DELETE_SUPPLICATION_ERROR: any = "DELETE_SUPPLICATION_ERROR";

export interface DeleteSupplicationConsentAction {
  type: typeof DELETE_SUPPLICATION_CONSENT;
  payload: string;
}

export interface DeleteSupplicationAction {
  type: typeof DELETE_SUPPLICATION;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteSupplicationSuccessAction {
  type: typeof DELETE_SUPPLICATION_SUCCESS;
  payload: null;
}

export interface DeleteSupplicationErrorAction {
  type: typeof DELETE_SUPPLICATION_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetSupplicationsAction
  | GetSupplicationsSuccessAction
  | GetSupplicationsErrorAction
  | GetSupplicationAction
  | GetSupplicationSuccessAction
  | GetSupplicationErrorAction
  | AddSupplicationAction
  | AddSupplicationSuccessAction
  | AddSupplicationErrorAction
  | UpdateSupplicationAction
  | UpdateSupplicationSuccessAction
  | UpdateSupplicationErrorAction
  | DeleteSupplicationConsentAction
  | DeleteSupplicationAction
  | DeleteSupplicationSuccessAction
  | DeleteSupplicationErrorAction;
